import { styled } from 'styled-components'

export const InfoTable = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--Padding-4, 1rem);
  align-self: stretch;
  cursor: default;
`
